import { render, staticRenderFns } from "./index.vue?vue&type=template&id=398c9ffc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=398c9ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c9ffc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('398c9ffc')) {
      api.createRecord('398c9ffc', component.options)
    } else {
      api.reload('398c9ffc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=398c9ffc&scoped=true&", function () {
      api.rerender('398c9ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/components/orderTo/sellCollect/index.vue"
export default component.exports